<template>
  <b-modal :id="id" @ok="callOk" @hide="hide" @shown="shown()" :title="title">
    <template slot="default">
      <div class="row">

        <div v-if="showWarehouseSelect" class="col-12 mb-3">
          <label for="warehouseSelect">Armazém</label>
          <div v-if="loadingWarehouses">
            <loading-animation />
          </div>
          <model-list-select
            v-else
            id="warehouseSelect"
            :list="warehouses"
            option-value="id"
            option-text="name"
            v-model="selectedWarehouse"
            placeholder="Armazém"
          />
          <small class="text-muted">{{ shared.LOCATIONS_WITH_SAME_NAME_AND_DIFFERENT_WAREHOUSES_MESSAGE }}</small>
        </div>

        <div class="col-12">
          <div v-if="loading" class="mb-2">
            <loading-animation />
          </div>

          <div v-else>
            <div v-if="useCamera">
              <StreamBarcodeReader
                @decode="onDecode"
                @loaded="onLoaded"
              ></StreamBarcodeReader>
            </div>
            <b-form-input v-else v-model="barcode" @keyup.enter="callOk" @keydown.tab="callOk" ref="barcodeInput" />
          </div>

          <p v-if="lastBarcode && lastBarcode.length" class="mt-3 text-center">
            Último código de barras: {{lastBarcode}}
          </p>
        </div>

        <div v-if="withQuantity" label="Quantidade" class="col-12 mb-0 mt-3">
          <label for="quantity" class="mb-0 margin-right pb-2">Quantidade a ser {{ isEntrance ? 'inserida' : 'removida'}}:</label>
          <div class="row align-items-center">
            <div v-if="itemLot && itemLot.quantityPerVolume" class="col">
              <b-form-input type="text" v-model="numberOfValues"/>
            </div>
            <div v-if="itemLot && itemLot.quantityPerVolume" class="col-auto px-0">
              <span class="text-muted">x </span> {{ itemLot.quantityPerVolume }} =
            </div>
            <div class="col">
              <b-form-input type="text" v-model="quantity"/>
            </div>
          </div>
        </div>

      </div>

    </template>

    <template slot="modal-footer" slot-scope="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">Cancelar</b-button>
      <b-button :disabled="loading" variant="primary" @click="callOk">Ok</b-button>
    </template>
  </b-modal>
</template>

<script>
  import { LoadingAnimation } from '@/components/loaders';
  import { StreamBarcodeReader } from "vue-barcode-reader";
  import shared from '@/shared/shared';
  import { httpClient } from '@/service'
  import { ModelListSelect } from 'vue-search-select'

  export default {
    name: 'barcode-input-modal',
    components: {
      LoadingAnimation,
      ModelListSelect,
      StreamBarcodeReader
    },

    props: {
      id: {
        type: String,
        require
      },
      title: {
        type: String,
        default: 'Insira o código de barras'
      },
      attempts: {
        type: Number
      },
      loading: {
        type: Boolean
      },
      withQuantity: {
        type: Boolean,
        default: false
      },
      isEntrance: {
        type: Boolean
      },
      initialQuantity: {},
      ok: {
        type: Function,
        default () {
          return;
        },
      },
      hide: {
        type: Function,
        default () {
          return;
        },
      },
      itemLot: {
        type: Object
      },
      config: {
        type: Object
      },
      authUser: {
        type: Object
      },
      parameter: {
        type: Object
      },
      showWarehouseSelect: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        lastBarcode: null,
        barcode: null,
        quantity: null,
        numberOfValues: null,
        innerConfig: {},
        warehouses: [],
        selectedWarehouse: {},
        loadingWarehouses: false,
        shared: shared
      }
    },

    computed: {
      useCamera() {
        return shared.useCamera(this.parameter, this.innerConfig);
      }
    },

    methods: {
      focusBarcodeInput() {
        this.barcode = null;

        if (this.$refs.barcodeInput) {
          let _this = this;
          setTimeout(() => {
            if (_this.$refs.barcodeInput) {
              _this.$refs.barcodeInput.$el.focus();
            }
          }, 500);
        }
      },

      callOk() {
        this.ok(this.barcode, this.quantity, this.selectedWarehouse);
      },

      shown() {
        if (this.config) {
          this.innerConfig = this.config;
        } else {
          this.innerConfig = shared.getConfig();
        }

        if (!this.useCamera) {
          this.focusBarcodeInput();
        }

        if (this.showWarehouseSelect && (!this.warehouses || !this.warehouses.length)) {
          this.getWarehouses();
        }
      },

      onDecode(text) {
        //console.log(`Decode text from QR code is ${text}`)
        this.barcode = text;
        this.callOk();
      },

      onLoaded() {
        console.log(`Leitor de códigos de barra carregado`)
      },

      getWarehouses() {
        this.loadingWarehouses = true;
        httpClient
        .post(`${process.env.VUE_APP_API_URL}stock-locales/condition?page=${0}&size=${100}`, {
          conditions: [{
            field: 'active',
            value: true
          }]
        }).then(({ data }) => {
          this.loadingWarehouses = false;
          this.warehouses = data.data.content;
        })
        .catch((error) => {
          this.loadingWarehouses = false;
          if (error.message) {
            this.$notify.error(error)
          } else {
            this.$notify.textError("Houve um erro ao buscar os armazéns");
          }
        });
      },
    },

    watch: {
      attempts(newValue, oldValue) {
        if (this.barcode && this.barcode.length) {
          this.lastBarcode = this.barcode;
        }

        this.focusBarcodeInput();
      },

      initialQuantity(newValue, oldValue) {
        if (this.withQuantity) {
          this.quantity = newValue;
          this.numberOfValues = 1;
        }
      },

      numberOfValues(newValue, oldValue) {
        if(this.quantity && this.itemLot && this.itemLot.quantityPerVolume && newValue){
          this.$set(this, 'quantity', newValue * this.itemLot.quantityPerVolume)
        }
      }
    }
  }
</script>

<style scoped>
</style>
